import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authenticationService';
import { BaseComponent } from 'app/shared/baseClasses/BaseComponent';
import { EventAggregator, EventList } from '../shared/utility/EventAggregator';
import { Routes, StorageConstants } from 'app/shared/utility/constants';
import { AppInsightService } from 'app/shared/services/app-insight.service';

@Component({
  selector: 'saml-login',
  templateUrl: './saml-login.component.html',
  styleUrls: ['./saml-login.component.css']
})
export class SamlLoginComponent extends BaseComponent implements OnInit {
  private token: string;
  private expires: string;
  private email: string;

  constructor(
    private config: AppConfig,
    private route: ActivatedRoute,
    private router: Router,
    private appInsightService: AppInsightService
  ) {
    super(config);
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'];
    this.expires = this.route.snapshot.queryParams['expires'];
    this.email = this.route.snapshot.queryParams['email'];

    sessionStorage.setItem(StorageConstants.BearerToken, this.token);
    sessionStorage.setItem(StorageConstants.TokenExpires, this.expires);
    console.log(`Setting Application Insight UserId to ${this.email}`);
    this.appInsightService.setUserId(this.email);

    this.router.navigate([Routes.Dashboard]);
  }
}
